const navbar = [
    { title: "Home", path: "/" },
    { title: "About", path: "/about" },
    { title: "Our Projects", path: "/projects" },
    { title: "Gallery ", path: "/gallery" },
    { title: "Contact", path: "/contactus" },


  ];
  
  export default navbar; // ✅ this line is needed
  